/**
 * Tier System Types
 * Types for user tier-based rate limiting
 */

export type UserTier = 'free' | 'pro' | 'enterprise';

export type OperationType = 'content_save' | 'chat_message' | 'learning_path' | 'total_content';

export type WindowType = 'daily' | 'weekly' | 'total';

export interface TierLimit {
    tier: UserTier;
    operationType: OperationType;
    limitValue: number; // -1 for unlimited
    windowType: WindowType;
}

export interface UsageInfo {
    current: number;
    limit: number;
    resetTime?: string;
    resetIn?: string;
}

export interface PromptStatus {
    showWarning: boolean;
    showUrgent: boolean;
    showUpgrade: boolean;
}

export interface UserUsage {
    tier: UserTier;
    usage: {
        contentSaves: UsageInfo;
        chatMessages: UsageInfo;
        learningPaths: UsageInfo;
        totalContent: {
            current: number;
            limit: number;
        };
    };
}

export interface RateLimitError {
    error: string;
    message: string;
    usage: {
        current: number;
        limit: number;
        resetTime: string;
        resetIn: string;
    };
    tier: UserTier;
    upgrade?: {
        suggested: UserTier;
        message: string;
    };
}

export interface UsageApiResponse {
    success: boolean;
    data: UserUsage;
}

// Tier display names
export const TIER_DISPLAY_NAMES: Record<UserTier, string> = {
    free: 'Free',
    pro: 'Pro',
    enterprise: 'Enterprise'
};

// Tier colors for UI
export const TIER_COLORS: Record<UserTier, string> = {
    free: 'gray',
    pro: 'blue',
    enterprise: 'purple'
};
